export type PriceItem = {
  name: {
    en: string
    ua: string
    ru: string
    ro: string
  }
  price: string
}

export type Category = {
  id: string
  anchorId: string
  title: {
    en: string
    ua: string
    ru: string
    ro: string
  }
  items: PriceItem[]
}

export const categories: Category[] = [
  {
    id: 'consultations',
    anchorId: 'consultations',
    title: {
      en: 'Consultations',
      ua: 'Консультації',
      ru: 'Консультации',
      ro: 'Consultații',
    },
    items: [
      {
        name: {
          en: 'New Patient Exam (incl. 2 X-Rays)',
          ua: 'Огляд нового пацієнта (вкл. 2 знімки)',
          ru: 'Осмотр нового пациента (вкл. 2 снимка)',
          ro: 'Examinare Pacient Nou (incl. 2 Radiografii)',
        },
        price: '£60',
      },
      {
        name: {
          en: 'Routine Check Up',
          ua: 'Плановий огляд',
          ru: 'Плановый осмотр',
          ro: 'Control de Rutină',
        },
        price: '£50',
      },
      {
        name: {
          en: 'Emergency Appointment',
          ua: 'Екстрений прийом',
          ru: 'Экстренный прием',
          ro: 'Consultație de Urgență',
        },
        price: '£75',
      },
      {
        name: {
          en: 'Orthodontics Consultation',
          ua: 'Консультація ортодонта',
          ru: 'Консультация ортодонта',
          ro: 'Consultație Ortodontică',
        },
        price: '£70',
      },
    ],
  },
  {
    id: 'hygiene',
    anchorId: 'dental-hygiene',
    title: {
      en: 'Dental Hygiene',
      ua: 'Гігієна',
      ru: 'Гигиена',
      ro: 'Igienă Dentară',
    },
    items: [
      {
        name: {
          en: 'Scale & Polish',
          ua: 'Чистка та полірування',
          ru: 'Чистка и полировка',
          ro: 'Detartraj și Periaj',
        },
        price: '£95',
      },
      {
        name: {
          en: 'Airflow Stain Removal',
          ua: 'Видалення нальоту Airflow',
          ru: 'Удаление налета Airflow',
          ro: 'Îndepărtarea Petelor cu Airflow',
        },
        price: '£45',
      },
      {
        name: {
          en: 'Scale & Polish + Airflow + Whitening',
          ua: 'Чистка + Airflow + відбілювання',
          ru: 'Чистка + Airflow + отбеливание',
          ro: 'Detartraj + Airflow + Albire',
        },
        price: '£350',
      },
      {
        name: {
          en: 'Deep Cleaning (per quadrant)',
          ua: 'Глибока чистка (1 квадрант)',
          ru: 'Глубокая чистка (1 квадрант)',
          ro: 'Curățare Profundă (per cadran)',
        },
        price: '£190',
      },
      {
        name: {
          en: 'Curettage (1–3 teeth)',
          ua: 'Кюретаж (1–3 зуби)',
          ru: 'Кюретаж (1–3 зуба)',
          ro: 'Chiuretaj (1–3 dinți)',
        },
        price: '£60–80',
      },
    ],
  },
  {
    id: 'general',
    anchorId: 'fillings-restorations',
    title: {
      en: 'Fillings & Restorations',
      ua: 'Пломби та реставрації',
      ru: 'Пломбы и реставрации',
      ro: 'Plombe și Restaurări',
    },
    items: [
      {
        name: {
          en: 'Composite Filling (small)',
          ua: 'Композитна пломба (мала)',
          ru: 'Композитная пломба (малая)',
          ro: 'Plombă Compozită (mică)',
        },
        price: '£120–150',
      },
      {
        name: {
          en: 'Composite Filling (medium)',
          ua: 'Композитна пломба (середня)',
          ru: 'Композитная пломба (средняя)',
          ro: 'Plombă Compozită (medie)',
        },
        price: '£150–180',
      },
      {
        name: {
          en: 'Composite Filling (large)',
          ua: 'Композитна пломба (велика)',
          ru: 'Композитная пломба (большая)',
          ro: 'Plombă Compozită (mare)',
        },
        price: '£180–250',
      },
      {
        name: {
          en: 'Composite Bonding',
          ua: 'Композитний бондинг',
          ru: 'Композитный бондинг',
          ro: 'Bonding Compozit',
        },
        price: '£250',
      },
      {
        name: {
          en: 'Tooth Restoration / Build up',
          ua: 'Реставрація / нарощування зуба',
          ru: 'Реставрация / наращивание зуба',
          ro: 'Restaurare / Reconstituire Dinte',
        },
        price: '£200',
      },
      {
        name: {
          en: 'Fiber Post',
          ua: 'Скловолоконний штифт',
          ru: 'Стекловолоконный штифт',
          ro: 'Pivot din Fibră',
        },
        price: '£150',
      },
      {
        name: {
          en: 'Temporary Filling',
          ua: 'Тимчасова пломба',
          ru: 'Временная пломба',
          ro: 'Plombă Provizorie',
        },
        price: '£50',
      },
      {
        name: {
          en: 'Re-cement Crown (each)',
          ua: 'Цементування коронки (1 шт.)',
          ru: 'Цементирование коронки (1 шт.)',
          ro: 'Recimentare Coroană',
        },
        price: '£80–119',
      },
    ],
  },
  {
    id: 'children',
    anchorId: 'children',
    title: {
      en: "Children's Dental Treatment",
      ua: 'Дитяча стоматологія',
      ru: 'Детская стоматология',
      ro: 'Tratament Dentar Pediatric',
    },
    items: [
      {
        name: {
          en: 'Routine Dental Examination',
          ua: 'Плановий огляд',
          ru: 'Плановый осмотр',
          ro: 'Examinare Dentară de Rutină',
        },
        price: '£60',
      },
      {
        name: {
          en: 'Child Adaptation Visit / Introductory Visit',
          ua: 'Адаптація дитини до візиту / ознайомчий візит',
          ru: 'Адаптация ребёнка к визиту / ознакомительный визит',
          ro: 'Vizită de adaptare a copilului / vizită introductivă',
        },
        price: '£60',
      },
      {
        name: {
          en: 'Dental Hygiene / Cleaning (child)',
          ua: 'Гігієна / чистка (дитина)',
          ru: 'Гигиена / чистка (ребенок)',
          ro: 'Igienă / Curățare (copil)',
        },
        price: '£65',
      },
      {
        name: {
          en: 'Fluoride Application',
          ua: 'Фторування',
          ru: 'Фторирование',
          ro: 'Aplicare Fluor',
        },
        price: '£25',
      },
      {
        name: {
          en: 'Fissure Sealant (per tooth)',
          ua: 'Герметизація фісур (1 зуб)',
          ru: 'Герметизация фиссур (1 зуб)',
          ro: 'Sigilare Fisuri',
        },
        price: '£50',
      },
      {
        name: {
          en: 'White Filling (baby tooth)',
          ua: 'Біла пломба (молочний зуб)',
          ru: 'Белая пломба (молочный зуб)',
          ro: 'Plombă Albă (dinte de lapte)',
        },
        price: '£80–120',
      },
      {
        name: {
          en: 'Metal Crown (Stainless Steel Crown)',
          ua: 'Металева коронка (дитяча)',
          ru: 'Металлическая коронка (детская)',
          ro: 'Coroană metalică pediatrică',
        },
        price: '£180',
      },
      {
        name: {
          en: 'Simple Extraction (baby / primary tooth)',
          ua: 'Просте видалення (молочний зуб)',
          ru: 'Простое удаление (молочный зуб)',
          ro: 'Extracție Simplă (dinte de lapte)',
        },
        price: '£50–120',
      },
      {
        name: {
          en: 'Pulpotomy',
          ua: 'Пульпотомія',
          ru: 'Пульпотомия',
          ro: 'Pulpotomie',
        },
        price: '£180–200',
      },
      {
        name: {
          en: 'Root Canal Treatment (baby tooth)',
          ua: 'Лікування каналів (молочний зуб)',
          ru: 'Лечение каналов (молочный зуб)',
          ro: 'Tratament de Canal (dinte de lapte)',
        },
        price: '£200–250',
      },
    ],
  },
  {
    id: 'root-canal',
    anchorId: 'root-canal',
    title: {
      en: 'Root Canal Treatment',
      ua: 'Лікування каналів',
      ru: 'Лечение каналов',
      ro: 'Tratament de Canal',
    },
    items: [
      {
        name: {
          en: 'Incisor',
          ua: 'Різець',
          ru: 'Резец',
          ro: 'Incisiv',
        },
        price: '£400',
      },
      {
        name: {
          en: 'Premolar',
          ua: 'Премоляр',
          ru: 'Премоляр',
          ro: 'Premolar',
        },
        price: '£500',
      },
      {
        name: {
          en: 'Molar',
          ua: 'Моляр',
          ru: 'Моляр',
          ro: 'Molar',
        },
        price: '£600',
      },
      {
        name: {
          en: 'Re-Root (Incisor)',
          ua: 'Перелікування (різець)',
          ru: 'Перелечивание (резец)',
          ro: 'Retratament Canal (Incisiv)',
        },
        price: '£600',
      },
      {
        name: {
          en: 'Re-Root (Premolar)',
          ua: 'Перелікування (премоляр)',
          ru: 'Перелечивание (премоляр)',
          ro: 'Retratament Canal (Premolar)',
        },
        price: '£750',
      },
      {
        name: {
          en: 'Re-Root (Molar)',
          ua: 'Перелікування (моляр)',
          ru: 'Перелечивание (моляр)',
          ro: 'Retratament Canal (Molar)',
        },
        price: '£850',
      },
    ],
  },
  {
    id: 'cosmetic',
    anchorId: 'whitening',
    title: {
      en: 'Whitening & Cosmetic',
      ua: 'Відбілювання та естетика',
      ru: 'Отбеливание и эстетика',
      ro: 'Albire și Estetică',
    },
    items: [
      {
        name: {
          en: 'Clinical Teeth Whitening',
          ua: 'Клінічне відбілювання',
          ru: 'Клиническое отбеливание',
          ro: 'Albire Dentară Clinică',
        },
        price: '£280',
      },
      {
        name: {
          en: 'Home Whitening Kit',
          ua: 'Домашній набір для відбілювання',
          ru: 'Домашний набор для отбеливания',
          ro: 'Kit de Albire la Domiciliu',
        },
        price: '£275',
      },
      {
        name: {
          en: 'Intracanal Bleaching (1 tooth)',
          ua: 'Внутрішньо-канальне відбілювання (1 зуб)',
          ru: 'Внутриканальное отбеливание (1 зуб)',
          ro: 'Albire Intracanală (1 dinte)',
        },
        price: '£150',
      },
      {
        name: {
          en: 'Professional Smile Package (incl. professional hygiene appointment, Airflow stain removal, and professional teeth whitening)',
          ua: 'Професійний пакет для усмішки (вкл. професійну гігієну, видалення нальоту Airflow та професійне відбілювання зубів)',
          ru: 'Профессиональный пакет для улыбки (вкл. профессиональную гигиену, удаление налета Airflow и профессиональное отбеливание зубов)',
          ro: 'Pachet Zâmbet Profesional (incl. programare de igienă profesională, îndepărtarea petelor cu Airflow și albirea profesională a dinților)',
        },
        price: '£350',
      },
    ],
  },
  {
    id: 'extraction',
    anchorId: 'extractions',
    title: {
      en: 'Tooth Extraction & Oral Surgery',
      ua: 'Видалення та хірургія',
      ru: 'Удаление и хирургия',
      ro: 'Extracții și Chirurgie Orală',
    },
    items: [
      {
        name: {
          en: 'Simple Extraction',
          ua: 'Просте видалення',
          ru: 'Простое удаление',
          ro: 'Extracție Simplă',
        },
        price: 'from £120',
      },
      {
        name: {
          en: 'Surgical Extraction',
          ua: 'Хірургічне видалення',
          ru: 'Хирургическое удаление',
          ro: 'Extracție Chirurgicală',
        },
        price: 'from £180–250',
      },
      {
        name: {
          en: 'Wisdom Tooth Removal',
          ua: 'Видалення зуба мудрості',
          ru: 'Удаление зуба мудрости',
          ro: 'Extracția Molarului de Minte',
        },
        price: 'from £180–350',
      },
      {
        name: {
          en: 'Apicectomy',
          ua: 'Апікоектомія',
          ru: 'Апикоэктомия',
          ro: 'Apicectomie',
        },
        price: '£600',
      },
      {
        name: {
          en: 'Bone Grafting',
          ua: 'Кісткова пластика',
          ru: 'Костная пластика',
          ro: 'Grefă Osoasă',
        },
        price: 'from £350',
      },
      {
        name: {
          en: 'Frenectomy',
          ua: 'Френектомія',
          ru: 'Френэктомия',
          ro: 'Frenectomie',
        },
        price: '£250–350',
      },
    ],
  },
  {
    id: 'dentures',
    anchorId: 'dentures',
    title: {
      en: 'Dentures',
      ua: 'Протези',
      ru: 'Протезы',
      ro: 'Proteze Dentare',
    },
    items: [
      {
        name: {
          en: 'Full Acrylic Denture (one arch)',
          ua: 'Повний акриловий протез (одна щелепа)',
          ru: 'Полный акриловый протез (одна челюсть)',
          ro: 'Proteză Acrilică Totală (o arcadă)',
        },
        price: '£900',
      },
      {
        name: {
          en: 'Partial Acrylic Denture',
          ua: 'Частковий акриловий протез',
          ru: 'Частичный акриловый протез',
          ro: 'Proteză Acrilică Parțială',
        },
        price: '£600',
      },
      {
        name: {
          en: 'Chrome Cobalt Dentures',
          ua: 'Бюгельний протез',
          ru: 'Бюгельный протез',
          ro: 'Proteze Crom-Cobalt',
        },
        price: '£1100',
      },
      {
        name: {
          en: 'Denture Repair',
          ua: 'Ремонт протеза',
          ru: 'Ремонт протеза',
          ro: 'Reparare Proteză',
        },
        price: 'from £250',
      },
    ],
  },
  {
    id: 'crowns-veneers',
    anchorId: 'crowns-veneers',
    title: {
      en: 'Crowns, Veneers & Bridges',
      ua: 'Коронки, вініри та мости',
      ru: 'Коронки, виниры и мосты',
      ro: 'Coroane, Fațete și Punți',
    },
    items: [
      {
        name: {
          en: 'Metal-Ceramic Crown',
          ua: 'Металокерамічна коронка',
          ru: 'Металлокерамическая коронка',
          ro: 'Coroană Metalo-Ceramică',
        },
        price: '£550',
      },
      {
        name: {
          en: 'Zirconia Crown',
          ua: 'Цирконієва коронка',
          ru: 'Циркониевая коронка',
          ro: 'Coroană de Zirconiu',
        },
        price: '£600–750',
      },
      {
        name: {
          en: 'E.max Veneer',
          ua: 'Вінір E.max',
          ru: 'Винир E.max',
          ro: 'Fațetă E.max',
        },
        price: '£600–750',
      },
      {
        name: {
          en: 'Composite Veneer',
          ua: 'Композитний вінір',
          ru: 'Композитный винир',
          ro: 'Fațetă Compozită',
        },
        price: '£350',
      },
      {
        name: {
          en: 'Porcelain Bridge (per unit)',
          ua: 'Керамічний міст (1 одиниця)',
          ru: 'Керамический мост (1 единица)',
          ro: 'Punte de Porțelan (per unitate)',
        },
        price: '£600',
      },
      {
        name: {
          en: 'Ceramic Inlay / Onlay / Overlay',
          ua: 'Керамічна вкладка / накладка / оверлей',
          ru: 'Керамическая вкладка / накладка / оверлей',
          ro: 'Inlay / Onlay / Overlay Ceramic',
        },
        price: '£450',
      },
      {
        name: {
          en: 'Temporary Crown',
          ua: 'Тимчасова коронка',
          ru: 'Временная коронка',
          ro: 'Coroană Temporară',
        },
        price: '£250–£300',
      },
    ],
  },
  {
    id: 'orthodontics',
    anchorId: 'orthodontics',
    title: {
      en: 'Orthodontics',
      ua: 'Ортодонтія',
      ru: 'Ортодонтия',
      ro: 'Ortodonție',
    },
    items: [
      {
        name: {
          en: 'Orthodontic consultation',
          ua: 'Ортодонтична консультація',
          ru: 'Ортодонтическая консультация',
          ro: 'Consultație ortodontică',
        },
        price: '£70',
      },
      {
        name: {
          en: 'Clear Aligners — Mild Case',
          ua: 'Прозорі елайнери — легкий випадок',
          ru: 'Прозрачные элайнеры — лёгкий случай',
          ro: 'Aligneri transparenți — caz ușor',
        },
        price: 'from £2,995',
      },
      {
        name: {
          en: 'Clear Aligners — Moderate Case',
          ua: 'Прозорі елайнери — помірний випадок',
          ru: 'Прозрачные элайнеры — умеренный случай',
          ro: 'Aligneri transparenți — caz moderat',
        },
        price: 'from £3,995',
      },
      {
        name: {
          en: 'Clear Aligners — Complex Case',
          ua: 'Прозорі елайнери — складний випадок',
          ru: 'Прозрачные элайнеры — сложный случай',
          ro: 'Aligneri transparenți — caz complex',
        },
        price: 'from £4,995',
      },
      {
        name: {
          en: 'Metal braces (1 arch)',
          ua: 'Металеві брекети (1 щелепа)',
          ru: 'Металлические брекеты (1 челюсть)',
          ro: 'Aparat dentar metalic (1 arcadă)',
        },
        price: '£600',
      },
      {
        name: {
          en: 'Metal braces (2 arches)',
          ua: 'Металеві брекети (2 щелепи)',
          ru: 'Металлические брекеты (2 челюсти)',
          ro: 'Aparat dentar metalic (2 arcade)',
        },
        price: '£1,100',
      },
      {
        name: {
          en: 'Ceramic braces (1 arch)',
          ua: 'Керамічні брекети (1 щелепа)',
          ru: 'Керамические брекеты (1 челюсть)',
          ro: 'Aparat dentar ceramic (1 arcadă)',
        },
        price: '£800',
      },
      {
        name: {
          en: 'Ceramic braces (2 arches)',
          ua: 'Керамічні брекети (2 щелепи)',
          ru: 'Керамические брекеты (2 челюсти)',
          ro: 'Aparat dentar ceramic (2 arcade)',
        },
        price: '£1,600',
      },
      {
        name: {
          en: 'Tightening / adjustment appointment',
          ua: 'Активація / корекція брекетів',
          ru: 'Активация / коррекция брекетов',
          ro: 'Activare / ajustare aparat dentar',
        },
        price: '£160',
      },
      {
        name: {
          en: 'Complete Braces Removal Package (incl. brace removal, adhesive removal & polishing, custom clear retainers — upper & lower, and bonded fixed retainers — upper & lower)',
          ua: 'Повний пакет зняття брекетів (зняття брекетів, видалення адгезиву та полірування, індивідуальні прозорі ретейнери — верхня та нижня щелепи, незнімні ретейнери — верхня та нижня щелепи)',
          ru: 'Полный пакет снятия брекетов (снятие брекетов, удаление адгезива и полировка, индивидуальные прозрачные ретейнеры — верхняя и нижняя челюсти, несъёмные ретейнеры — верхняя и нижняя челюсти)',
          ro: 'Pachet complet de îndepărtare a aparatului (îndepărtarea aparatului, îndepărtarea adezivului și lustruire, retaineri transparenți personalizați — arcadă superioară și inferioară, și retaineri ficși — arcadă superioară și inferioară)',
        },
        price: '£800',
      },
      {
        name: {
          en: 'Removable retainer',
          ua: 'Знімний ретейнер',
          ru: 'Съёмный ретейнер',
          ro: 'Retainer mobil',
        },
        price: '£200',
      },
      {
        name: {
          en: 'Fixed metal retainer',
          ua: 'Незнімний металевий ретейнер',
          ru: 'Несъёмный металлический ретейнер',
          ro: 'Retainer metalic fix',
        },
        price: '£200',
      },
      {
        name: {
          en: 'Sports mouthguard',
          ua: 'Спортивна капа',
          ru: 'Спортивная капа',
          ro: 'Gutieră sportivă',
        },
        price: 'from £250',
      },
    ],
  },
  {
    id: 'radiography',
    anchorId: 'radiography',
    title: {
      en: 'Radiography',
      ua: 'Рентгенографія',
      ru: 'Рентгенография',
      ro: 'Radiografie',
    },
    items: [
      {
        name: {
          en: 'Small X-ray',
          ua: 'Малий знімок',
          ru: 'Малый снимок',
          ro: 'Radiografie Mică',
        },
        price: '£20',
      },
      {
        name: {
          en: 'OPG',
          ua: 'Панорамний знімок (OPG)',
          ru: 'Панорамный снимок (OPG)',
          ro: 'OPG',
        },
        price: '£50',
      },
      {
        name: {
          en: 'Cephalometric',
          ua: 'Цефалометричний знімок',
          ru: 'Цефалометрический снимок',
          ro: 'Cefalometrică',
        },
        price: '£50',
      },
      {
        name: {
          en: 'CBCT (single jaw)',
          ua: 'КТ (одна щелепа)',
          ru: 'КТ (одна челюсть)',
          ro: 'CBCT (o arcadă)',
        },
        price: '£100',
      },
      {
        name: {
          en: 'CBCT (both jaws)',
          ua: 'КТ (обидві щелепи)',
          ru: 'КТ (обе челюсти)',
          ro: 'CBCT (ambele arcade)',
        },
        price: '£150',
      },
      {
        name: {
          en: 'CBCT (segment)',
          ua: 'КТ (сегмент)',
          ru: 'КТ (сегмент)',
          ro: 'CBCT (segment)',
        },
        price: '£80',
      },
    ],
  },
  {
    id: 'indirect',
    anchorId: 'indirect',
    title: {
      en: 'Indirect Restorations',
      ua: 'Непрямі реставрації',
      ru: 'Непрямые реставрации',
      ro: 'Restaurări Indirecte',
    },
    items: [
      {
        name: {
          en: 'Ceramic Inlay',
          ua: 'Керамічна вкладка',
          ru: 'Керамическая вкладка',
          ro: 'Inlay Ceramic',
        },
        price: '£400',
      },
      {
        name: {
          en: 'Ceramic Onlay',
          ua: 'Керамічна накладка',
          ru: 'Керамическая накладка',
          ro: 'Onlay Ceramic',
        },
        price: '£450',
      },
      {
        name: {
          en: 'Ceramic Overlay',
          ua: 'Керамічний оверлей',
          ru: 'Керамический оверлей',
          ro: 'Overlay Ceramic',
        },
        price: '£500',
      },
    ],
  },
  {
    id: 'implants',
    anchorId: 'implants',
    title: {
      en: 'Dental Implants',
      ua: 'Імплантація',
      ru: 'Имплантация',
      ro: 'Implanturi Dentare',
    },
    items: [
      {
        name: {
          en: 'Dental implant with crown',
          ua: 'Імплант із коронкою',
          ru: 'Имплант с коронкой',
          ro: 'Implant dentar cu coroană',
        },
        price: '£2,200',
      },
      {
        name: {
          en: 'Bone grafting / augmentation',
          ua: 'Підсадка / нарощування кістки',
          ru: 'Костная пластика / наращивание кости',
          ro: 'Adiție osoasă / augmentare osoasă',
        },
        price: '£650',
      },
    ],
  },
  {
    id: 'aesthetic',
    anchorId: 'injectables',
    title: {
      en: 'Injectables & Aesthetic',
      ua: "Ін'єкційна косметологія",
      ru: 'Инъекционная косметология',
      ro: 'Injectabile și Estetică',
    },
    items: [
      {
        name: {
          en: 'Botox',
          ua: 'Ботокс',
          ru: 'Ботокс',
          ro: 'Botox',
        },
        price: 'from £250',
      },
      {
        name: {
          en: 'Hydrafacial',
          ua: 'Гідрафейшл',
          ru: 'Гидрафейшл',
          ro: 'Hydrafacial',
        },
        price: '£250',
      },
    ],
  },
]
